import { useDimensions } from "@repo/core/hooks/useDimensions";
import { useNewTransactionStore } from "@repo/core/stores/newTransaction";
import { ROUTES } from "@repo/core/routes";
import { formatDate } from "@repo/core/utils/date.utils";
import { useNewTransactionFlow } from "@repo/core/hooks/useNewTransactionFlow";
import { useRef } from "react";
import { IModalRefProps } from "@repo/core/components/layout/Modal/types";
import {
  IModalOption,
  IModalTemplateType
} from "@repo/core/components/layout/ModalTemplate/types";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { useStoresAndShopkeepersStore } from "@repo/core/stores/storesAndShopkeepers";

export const NewTransactionReviewController = () => {
  // Hooks
  const { replace } = useNavigation();
  const { navigateBack, navigateToNext, customNavigate, currentFlow } =
    useNewTransactionFlow();
  const { isMobile } = useDimensions();

  // Store
  const {
    bonusValue,
    transactionValue,
    selectedInstallment,
    isInstallmentsPayment,
    discountedTransactionValue,
    availableBonus,
    interestType,
    qrCodeInfo,
    resetNewTransaction
  } = useNewTransactionStore();

  const { selectedStore } = useStoresAndShopkeepersStore();

  // Calculations
  const installmentValue =
    selectedInstallment?.dblValorPrestacao || discountedTransactionValue;
  const installmentTotal =
    (selectedInstallment?.dblValorPrestacao || 0) *
      (selectedInstallment?.intPrazo || 0) || discountedTransactionValue;

  // Verification
  const verifyIfDataIsSameAsQrCode = () => {
    if (qrCodeInfo) {
      const isInterestSameAsQrCode = interestType === qrCodeInfo.strSemJuros;
      const isTransactionValueSameAsQrCode =
        transactionValue === Number(qrCodeInfo.strValorCompra);
      const isInstallmentTimeSameAsQrCode =
        selectedInstallment?.intPrazo === Number(qrCodeInfo.strPrazo);

      return (
        isInterestSameAsQrCode &&
        isTransactionValueSameAsQrCode &&
        isInstallmentTimeSameAsQrCode
      );
    }

    return false;
  };

  // Data
  const transactionData = {
    date: formatDate(new Date()),
    paymentMethod: isInstallmentsPayment
      ? "Crédito Parcelado"
      : "Crédito à Vista",
    installments: selectedInstallment?.intPrazo,
    availableBonus,
    subtotal: discountedTransactionValue,
    bonus: bonusValue || 0,
    total: transactionValue,
    installmentValue,
    installmentTotal
  };

  const alertModalRef = useRef<IModalRefProps>(null);

  // Navigation Handlers
  const handleNavigateBack = () => {
    navigateBack();
  };

  const handleNavigateToConfirm = () => {
    const dataIsSameAsQrCode = verifyIfDataIsSameAsQrCode();
    if (dataIsSameAsQrCode) {
      alertModalRef.current?.open();
    } else {
      navigateToNext();
    }
  };

  const handleNavigateToFidelity = () => {
    customNavigate({
      to: ROUTES.newTransactionFidelityOptions,
      next: ROUTES.newTransactionReview
    });
  };

  const handleNavigateToValue = () => {
    customNavigate({
      to: ROUTES.newTransactionValue,
      next: ROUTES.newTransactionReview
    });
  };
  const handleNavigateToHome = () => {
    replace(ROUTES.home);
    resetNewTransaction();
  };

  // Modal Options
  const alertOptions: IModalOption[] = [
    {
      label: "Voltar ao início",
      onPress: () => handleNavigateToHome(),
      type: IModalTemplateType.success
    },
    {
      label: "Ver comprovante",
      type: IModalTemplateType.outline,
      onPress: () => customNavigate({ to: ROUTES.newTransactionReceipt })
    }
  ];
  return {
    // Layout
    isMobile,

    // Data
    transactionData,
    isInstallmentsPayment,
    title: currentFlow.title,
    alertModalRef,
    alertOptions,
    selectedStore,

    // Handlers
    handleBack: handleNavigateBack,
    handleFinishTransaction: handleNavigateToConfirm,
    handleFidelityPress: handleNavigateToFidelity,
    handleValuePress: handleNavigateToValue
  };
};
